const m = require('mithril');
const prop = require('mithril/stream');
const L = require('leaflet');
const edit = require('../../layout/components/edit');

const BasePlugin = require('./basePlugin');
const diagramComponent = require('../../equipment/components/geoDiagram');
const equipmentDiagram = require('../../equipment/components/equipmentDiagram');
diagram = null;
class DiagramPlugin extends BasePlugin {
  constructor(ctrl) {
    super(ctrl);

    var diagramOverlay;

    this.ctrl.eventBus.on('mithril:oncreate', () => {
      let overlayDiv = this.ctrl.dom.querySelector('#mapoverlaydiv');

      this.ctrl.showDiagramOverlay = function () {
        overlayDiv.style.display = 'block';
      };

      this.ctrl.hideDiagramOverlay = function () {
        overlayDiv.style.display = 'none';
      }

      if (!this.ctrl?.systemRecord || !this.ctrl.systemRecord()) return;

      let bounds = L.latLngBounds();
      this.ctrl.thisLocationLayers.forEach(function(feature) {
        if (feature.getBounds) {
            // For layers that have defined bounds
            bounds.extend(feature.getBounds());
        } else if (feature.getLatLng) {
            // For point features like markers
            bounds.extend(feature.getLatLng());
        }
      });

      this.ctrl.bounds = bounds;
      this.ctrl.diagram = prop();
      let diagramComponentData = {
        useGeoPositioning: true,
        equipmentRecord: this.ctrl.systemRecord,
        parentCtrl: this.ctrl,
        equipmentRecordRid: this.ctrl.systemRecord['@rid'],
        systemRecord: this.ctrl.systemRecord,
        redrawDiagram: this.ctrl.redrawDiagram,
        diagram: this.ctrl.diagram,
        parentReinitialize: this.ctrl.parentReinitialize,
        parentReinitializeAndRedraw: this.ctrl.parentReinitializeAndRedraw,
        equipmetCoordinates: this.ctrl.equipmentCoordinates,
      }

      this.ctrl.map.whenReady(() => {
        m.mount(overlayDiv, {view: () => m(equipmentDiagram, diagramComponentData)});
        this.ctrl.showDiagramOverlay();
      });
    });
  }
}

module.exports = DiagramPlugin;
